import React from 'react';
import { styled } from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
export const DotSeparator = ({
  spaceAround = 8
}) => /*#__PURE__*/_jsx(StyledDotSeparator, {
  style: {
    margin: `auto ${spaceAround}px`
  },
  "aria-hidden": "true"
});
const StyledDotSeparator = styled.span.withConfig({
  displayName: "DotSeparator__StyledDotSeparator",
  componentId: "sc-mtay15-0"
})(["min-width:2px;min-height:2px;border-radius:50%;background-color:currentColor;"]);